export const formatEthValue = (eth: number) => {
    // three decimal places for values up to 2 ETH
    // two up to 10 ETH
    // one up to 20 ETH
    // none 20+
    if (eth < 2) return eth.toFixed(3);
    else if (eth < 10) return eth.toFixed(2);
    else if (eth < 20) return eth.toFixed(2);
    else return eth.toFixed(0);
};
